import React from 'react';
import Carousel from "react-multi-carousel";
import MovieCard from './MovieCard';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5,
    slidesToSlide: 3// optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
    slidesToSlide: 1 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};

const MovieSlide = ({ movies }) => {
    // console.log("movies", movies)
    return (
            <Carousel responsive={responsive} swipeable={true} showDots={true} containerClass="carousel-container" itemClass="carousel-item-padding-40-px">
                {
                    movies.results.map((item, idx) => (
                        <MovieCard item={item} key={idx} />
                    ))
                }
            </Carousel>
    )
}
const TvSlide = ({ movies }) => {
  console.log("movies", movies)
  return (
          <Carousel responsive={responsive} swipeable={true} showDots={true} containerClass="carousel-container" itemClass="carousel-item-padding-40-px">
              {
                  movies.results.map((item, idx) => (
                      <MovieCard item={item} key={idx} />
                  ))
              }
          </Carousel>
  )
}

export default MovieSlide